import React from "react";
import {ControlPosition, MapControl} from "@vis.gl/react-google-maps";
import {FaMapMarkerAlt} from "react-icons/fa";

const API_URL = import.meta.env.VITE_API_URL;

const MapElements = ({mapMode, onChangeMode}) => {
    const isHeatmap = mapMode === "heatmap";

    const modeButtonClass = (active) => [
        "flex items-center gap-1.5 px-3 py-1 rounded text-[13px] font-semibold cursor-pointer transition-colors",
        active ? "bg-white text-[#063A6C] shadow-sm" : "text-gray-500 hover:text-gray-700"
    ].join(" ");

    return (
        <MapControl position={ControlPosition.TOP_RIGHT}>
            <div className="flex bg-gray-100 border border-gray-300 rounded-md p-0.5 mr-3 mt-3 print:hidden">
                <button key={'marker-mode'} type="button" onClick={() =>  onChangeMode("marker")} className={modeButtonClass(!isHeatmap)}>
                    <FaMapMarkerAlt size={13} color={'#ef2929'}/>
                    Padrão
                </button>

                <button key={'heatmap-mode'} type="button" onClick={() =>  onChangeMode("heatmap")} className={modeButtonClass(isHeatmap)}>
                    <img src={`${API_URL}/public/assets/img/markers/iconThermalMap.svg`} className="w-[13px] h-[13px]" alt={'heatmap'}/>
                    Calor
                </button>
            </div>
        </MapControl>
    );
};

export default MapElements;